<template>
    <div :key="receiptKey">
        <breadCrumb 
            :icon="'fa-receipt'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_receipt`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                       <ul class="nav nav-tabs mb-5" role="tablist">
                            <li class="nav-item" v-for="receiptTab in $i18n.messages[$i18n.locale].tab.receiptTabs" :key="receiptTab.id">
                                <a :class="{'active': selectedTab == receiptTab.id}" class="nav-link" role="tab" @click="selectedTab = receiptTab.id">{{receiptTab.text}}</a>
                            </li>
                        </ul> 
                        <form @submit.prevent="submitForm">
                            <div class="tab-content mt-5">
                                <receiptContent ref="receiptContent" class="tab-pane" :class="{'active': selectedTab == 'receipt'}" :bizName ="results.bizName" :hideMobile="results.hideMobile" :address="results.address"></receiptContent>
                                <receiptFooter ref="receiptFooter" class="tab-pane" :class="{'active': selectedTab == 'footer'}" :footer="results.footer"></receiptFooter>
                                <receiptTax ref="receiptTax" class="tab-pane" :class="{'active': selectedTab == 'taxation'}" :taxation="results.taxation"></receiptTax>
                                <receiptTemplate ref="receiptTemplate" class="tab-pane" :class="{'active': selectedTab == 'template'}" :templateID="results.templeteID" :showCredits="results.showCredits" :showPoints="results.showPoints" :showOutstandings="results.showOutstandings" @update="update"></receiptTemplate>
                            </div>
                            <div class="text-left mt-3 mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import ReceiptContent from './Receipt_ReceiptContent'
import ReceiptFooter from './Receipt_Footer'
import ReceiptTax from './Receipt_Tax'
import ReceiptTemplate from './Receipt_Template'

export default {
    name:'receipt',
    components:{
        ReceiptContent, ReceiptFooter, ReceiptTax, ReceiptTemplate, BreadCrumb
    },
    data(){
        return{
            outlet: [], selectedOutlet: 0,
            selectedTab: 'receipt',
            results: [],
            receiptKey: 0
        }
    },
    methods:{
        closeModal(){
            if(!this.isError){
                this.getReceipt(this.selectedOutlet);
                this.outlet = JSON.parse(this.$store.state.outlets);
                this.selectedOutlet = this.outlet[0];    
                this.selectedTab = "receipt"
                this.receiptKey += 1;
            }
            this.$parent.isModalShow = false;
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.getReceipt(this.selectedOutlet);
        },
        submitForm(){
            let $vm = this;
            var receiptItem = this.$refs.receiptContent.submitReceipt();
            var footerItem = this.$refs.receiptFooter.submitFooter();
            var taxItem = this.$refs.receiptTax.submitTax();

            var data = Object.assign(this.results, receiptItem, footerItem, taxItem);
            
            const url = this.$api.BEBUSINESS_OUTLET + "/" + this.selectedOutlet.id + this.$api.RECEIPT + '/update'
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.salon_setting_receipt') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        getReceipt(outlet){
            let $vm = this
            // const url = this.$api.OUTLET + "/" + outlet.id + this.$api.RECEIPT
            const url = this.$api.BEBUSINESS_OUTLET + "/" + outlet.id + this.$api.RECEIPT
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                if(response.data && response.data[0]) {
                    $vm.results = response.data[0]
                } else {
                    throw Error()
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        update(key, value) {
            this.results[key] = value
        },
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.getReceipt($vm.selectedOutlet);
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>